import { render, staticRenderFns } from "./PortfolioSummary.vue?vue&type=template&id=2c38a52a&scoped=true"
import script from "./PortfolioSummary.vue?vue&type=script&lang=js"
export * from "./PortfolioSummary.vue?vue&type=script&lang=js"
import style0 from "./PortfolioSummary.vue?vue&type=style&index=0&id=2c38a52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38a52a",
  null
  
)

export default component.exports